import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BlogSectionSlider = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await axios.get(
          'https://www.startupbusinesspartners.com/api/blog',
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        );

        if (response.data.success) {
          setPosts(response.data.data);
        } else {
          throw new Error(response.data.message || 'Failed to fetch posts');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching blog posts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const getExcerpt = (content) => {
    const words = content?.split(' ') || [];
    return words.slice(0, 10).join(' ') + (words.length > 10 ? '...' : '');
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) {
    return (
      <div className="text-center py-8">
        <p>Loading blog posts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8 text-red-500">
        <p>Error loading blog posts: {error}</p>
      </div>
    );
  }

  return (
    <section className="py-24 bg-gray-100">
      <div className="container mx-auto px-4 bg-white shadow-lg rounded-lg p-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Our Latest Blog</h2>
          <p className="text-gray-600">Latest updates and articles from our community</p>
        </div>

        {posts.length > 0 ? (
          <Slider {...settings}>
            {posts.map((post) => (
              <div key={post.id} className="px-3">
                <div className="bg-white rounded-lg overflow-hidden shadow-md h-full flex flex-col">
                  <a href={`/blog/${post.slug}`}>
                    <img
                      src={`https://www.startupbusinesspartners.com/uploads/cms/${post.image_url || ''}`}
                      alt={post.title}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover',
                      }}
                    />
                  </a>
                  <div className="p-4 flex flex-col flex-grow">
              <h3 className="text-md font-small text-gray-800 mb-2" style={{fontSize:'17px'}}>
  <a href={`/blog/${post.slug}`} className="hover:text-blue-600 block">
    {post.title.split(' ').slice(0, 7).join(' ')}
    {post.title.split(' ').length > 7 ? '...' : ''}
  </a>
</h3>

                    <div className="text-sm text-gray-500 mb-2">
                      <span>{formatDate(post.created_at)}</span>
                      {post.tags && (
                        <span className="ml-3">
                          Tags: {post.tags.split(',').map(tag => tag.trim()).join(', ')}
                        </span>
                      )}
                    </div>
                    <p className="text-gray-600 text-sm flex-grow">
                      {getExcerpt(post.excerpt || post.content)}
                    </p>
                    <a
                      href={`/blog/${post.slug}`}
                      className="mt-4 inline-block text-blue-500 hover:underline font-medium"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="text-center py-8">No blog posts available at the moment.</div>
        )}
      </div>
    </section>
  );
};

export default BlogSectionSlider;
